export const RenderNoData = () => (
	<div className="panel-body">
		<div className="col-md-12 mt-4 ">
			{' '}
			<div className="table-responsive h500 mt-2">
				<div className="text-center">
					<span className="h6">No data</span>
				</div>
			</div>
		</div>
	</div>
);
